var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E7F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 10H22.0007C22.3689 10 22.6673 10.2985 22.6673 10.6667V21.3333C22.6673 21.7015 22.3689 22 22.0007 22H10.0007C9.63246 22 9.33398 21.7015 9.33398 21.3333V10.6667C9.33398 10.2985 9.63246 10 10.0007 10ZM21.334 12.8253L16.0485 17.5587L10.6673 12.8106V20.6667H21.334V12.8253ZM11.0083 11.3333L16.0419 15.7747L21.0013 11.3333H11.0083Z",
    fill: "#0D8091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailsIcon);
export default __webpack_public_path__ + "static/media/MailsIcon.bb1d5c7e0d0fa9d62a46da4309bc5282.svg";
export { ForwardRef as ReactComponent };